import React from 'react';
import LeftNav from './../common/leftnav/leftnav';
import HeaderTop from './../common/headerTop/headerTop';
import Validate from '../common/validate';
import CommonMessage from './../common/commonMessage';
import ReactToolTip from 'react-tooltip';
import $ from 'jquery';
import { API_HOST, axiosInstance, axiosRequestWithAuth } from './../../constants/server.constant';
import RegionService from './../../services/region.service';
import './../server/Region.css';
import { Redirect } from 'react-router-dom';
import { ResourceService } from './../../services/resource.service';
import ScrollArea from 'react-scrollbar';
import NotificationSlider from '../common/topRightHeader/notificationSlider';
import ServerService from '../../services/server.service';
import { NetworkService } from '../../services/network.service';
import ReactTooltip from 'react-tooltip';


class CreateLoadBal extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isRedirectCCPage: false,
            loadBalConfigLabel: "",
            loadBalConfigAlgorithm: "LEAST_CONNECTIONS",
            loadBalConfigCookie: "",
            showCookie: false,
            loadBalConfigStickySession: "NONE",
            portConfigPort: "80",
            portConfigProtocol: "HTTP",
            healthChecksType: "HTTP",
            healthChecksMaxRetriesDown: "3",
            healthChecksDelay: "10",
            healthChecksMaxRetries: "3",
            healthChecksTimeout: "5",
            healthChecksHttp: "GET",
            healthChecksSelectedECodes: [],
            healthChecksUrl: "/",
            members: [],
            countryName: "",
            isAction: false,
            regionListFilter: [],
            region: '',
            regionValue: '',
            regions: [],
            instanceList: [],
            filteredInstance: [],
            enableAttachInstance: false,
            enableEditInstance: false,
            detachInstance: false,
            attachInstaneList: [],
            instanceAttacher: "",
            selectedInstanceId: "",
            instanceIpAddrs: "",
            instancePort: "",
            instanceWeight: "",
            algorithmList: [],
            sessionTypes: [],
            protocols: [],
            healthChecks: [],
            httpMethods: [],
            expectedCodes: [],
            cookieEmpty: false,
            cookieError: false,
            labelError: false,
            maxRetriesDownEmpty: false,
            maxRetriesDownError: false,
            maxRetriesEmpty: false,
            maxRetriesError: false,
            portConfigPortEmpty: false,
            portConfigPortError: false,
            instanceEmpty: false,
            instanceError: false,
            delayRegex: false,
            timeOutRegex: false,
            urlEmpty: false,
            urlError: "",
            ecodeEmpty: false,
            isTypeNotHttpOrHttps: false,
            filterECodes: [],
            lbCost: 10,
            detachInstanceId: "",
            detachInstancename: "",
            showSpeed: false,
            setLink: "",
            regionCapacity: 0,
            regionText: true,
            isSuspended: localStorage.getItem("status") === "S"
        };
        this.scrollRef = React.createRef();
        this.attachSelect = React.createRef();
        this.checkForSubscription = this.checkForSubscription.bind(this);
        this.getRegionDropdown = this.getRegionDropdown.bind(this);
        this.getSelectedRegion = this.getSelectedRegion.bind(this);
        this.loadRegionUserNotSubscribed = this.loadRegionUserNotSubscribed.bind(this);
        this.loadRegions = this.loadRegions.bind(this);
        this.enableInstanceOptions = this.enableInstanceOptions.bind(this);
        this.enableInstanceOperations = this.enableInstanceOperations.bind(this);
        this.getInstanceList = this.getInstanceList.bind(this);
        this.escfunction = this.escfunction.bind(this);
        this.createLoadBalancer = this.createLoadBalancer.bind(this);
        this.setLoadBalConfig = this.setLoadBalConfig.bind(this);
        this.setPortConfig = this.setPortConfig.bind(this);
        this.setHealthChecks = this.setHealthChecks.bind(this);
        this.validateField = this.validateField.bind(this);
        this.labelRef = React.createRef();
        this.portConPortRef = React.createRef();
        this.retiresDownRef = React.createRef();
        this.retiresRef = React.createRef();
        this.timeoutRef = React.createRef();
        this.delayRef = React.createRef();
        this.urlRef = React.createRef();
        this.cookieRef = React.createRef();


    };

    componentWillUnmount() {
        document.removeEventListener("keyup", this.escfunction, false);
        $('body').removeClass("popup_no_scroll");
    }

    componentDidMount() {

        document.addEventListener("keyup", this.escfunction, false);
        //this.loadcss();
        this.setState({
            isAction: true
        });
        this.getLoadBalData();
        this.checkForSubscription();

    }


    checkRegionForSpeedLink = (region) => {
        let flag = true;
        /*let regionList = ["TX2","TX3","LA2","BOS1","CO1","ATL1","NJ1","PDX1","PX1",
        "LA3",
        "MIA1",
        "NC1",
        "ORD1",
        "PA1",
        "SEA1",
        "SFO1",
        "TX1",
        "VA1","NYC1"];
        for(let i=0;i<regionList.length;i++){
            if(regionList[i] == region){
                flag = true
            }
        }*/
        if(flag) {
            this.setState({
                showSpeed: true,
                setLink: "https://speedtest-" + region + ".idrivecompute.com"
            });
        }
        else {
            this.setState({
                showSpeed: false,
                setLink: ""
            });
        }

    };

    getLoadBalData = () => {
        let userId = localStorage.getItem("userId");
        axiosInstance.get(API_HOST + '/loadbal/getloadbalops/' + userId, axiosRequestWithAuth)
            .then(resp => {

                this.setState({
                    algorithmList: resp.data.algorithm,
                    sessionTypes: resp.data.sessionTypes,
                    protocols: resp.data.protocols,
                    healthChecks: resp.data.healthChecks,
                    httpMethods: resp.data.httpmethods,
                    expectedCodes: resp.data.expectedCodes,
                    filterECodes: resp.data.expectedCodes.slice(1),
                    healthChecksSelectedECodes: resp.data.expectedCodes.slice(0, 1),
                    healthChecksUrl: resp.data.url[0],
                });

            })
            .catch(error => {
                console.log(error);
            });
    };

    escfunction(event) {
        if(event.keyCode === 27) {
            this.setState({
                enableAttachInstance: false,
                enableEditInstance: false,
                detachInstance: false
            });

            $("body").removeClass("popup_no_scroll");


        }
    }
    enableInstanceOperations = (type, operation, instance) => {
        if(type === "attach") {
            this.setState({
                selectedInstanceId: "",
                instanceId: "",
                instanceIpAddrs: "",
                instancePort: "",
                instanceWeight: "",
                instanceEmpty: false,
                intsancePortEmpty: false,
                instancePortError: false,
                intsanceWeightEmpty: false,
                instanceWeightError: false
            });
            if(operation === "open") {
                this.setState({
                    enableAttachInstance: true
                });
                $("body").addClass("popup_no_scroll");
                setTimeout(() => {
                    this.attachSelect.current.focus();
                }, 100);
            }
            else {
                this.setState({
                    enableAttachInstance: false
                });
                $("body").removeClass("popup_no_scroll");
            }
        }
        else if(type === "edit") {
            if(operation === "open") {
                this.setState({
                    selectedInstanceId: instance.instanceId,
                    instanceId: instance.instanceId,
                    instanceName: instance.instanceName,
                    instanceIpAddrs: instance.instanceIp,
                    instancePort: instance.port,
                    instanceWeight: instance.weight,
                    instanceEmpty: false,
                    intsancePortEmpty: false,
                    instancePortError: false,
                    intsanceWeightEmpty: false,
                    instanceWeightError: false
                });
                this.setState({
                    enableEditInstance: true
                });
                $("body").addClass("popup_no_scroll");
            }
            else {
                this.setState({
                    enableEditInstance: false
                });
                $("body").removeClass("popup_no_scroll");
            }
        }
        else if(type === "detach") {
            this.setState({
                detachInstanceId: instance.instanceId,
                detachInstancename: instance.instanceName
            });
            if(operation === "open") {
                this.setState({
                    detachInstance: true
                });
                $("body").addClass("popup_no_scroll");
            }
            else {
                this.setState({
                    detachInstance: false
                });
                $("body").removeClass("popup_no_scroll");
            }
        }
    };
    getInstanceList = (regionId) => {
        ServerService.getRegionListByType('compute').then(regionList => {
            console.log(regionList);
            if(regionList.length > 0) {
                let region = regionList.find(regionItem => regionItem.region === regionId);

                this.setState({
                    regionUrl: region.url,
                    regionList: regionList
                }, () => this.getAttachedInstances(region.url, "beforeLoad"));

            }
            if(!Array.isArray(regionList)) {
                this.setState({ isAction: false });
            }
        });
    };
    getAttachedInstances(regionUrl, param) {
        if(param === "afterLoad")
            this.setState({ isAction: true });
        let attachedInstances = [];
        ServerService.getServerListByRegion(regionUrl).then(resp => {
            console.log(resp);
            if(resp && resp.length > 0) {
                resp.forEach(instance => {
                    if(instance.status == "ACTIVE") {

                        let fixData = {
                            "instanceId": instance.id,
                            "instanceName": instance.name,
                            "instanceAddrss": instance.ipaddress
                        };

                        attachedInstances.push(fixData);
                    }
                });

                this.setState({ instanceList: [...attachedInstances], filteredInstance: [...attachedInstances] });
            }
            else {
                this.setState({ instanceList: [], filteredInstance: [] });
            }
            this.setState({
                isAction: false,
                labelEmpty: false,
                labelError: false,
                maxRetriesDownEmpty: false,
                maxRetriesDownError: false,
                timeOutEmpty: false,
                timeOutError: false,
                delayError: false,
                maxRetriesError: false,
                maxRetriesEmpty: false,
                delayEmpty: false
            });

        });
    }
    getAdditionalIpDetails = () => {

        NetworkService.getIPDetailsByUser().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false
                });
            }
            if(resp.data == "NO_DETAILS_FOUND") {
                this.setState({
                    additionalIPs: [],
                    additionalIPCount: 0
                });
            }
            if(resp.data != "NO_DETAILS_FOUND") {
                this.setState({
                    additionalIPs: resp.data,
                    additionalIPCount: resp.data.length
                });

            }


        })
            .catch(error => {
                this.setState({
                    isAction: false
                });
            });
    };
    getMainIp = (serverId) => {
        let instances = this.state.filteredInstance;
        let ipList = instances.find(elem => elem.instanceId === serverId);
        ipList = ipList.instanceAddrss;
        let compute = this.state.additionalIPs;
        if(compute.length > 0) {
            let result = [];
            for(let i = 0; i < compute.length; i++) {
                if(compute[i].instance_id == serverId)
                    result.push(compute[i].ip_address);
            }
            var final = ipList.filter(function (obj) { return result.indexOf(obj) == -1; });
            return final[0];
        }
        else {
            return ipList[0];
        }

    };
    checkBmInstance = (flavorId) => {
        try {
            let flavorList = JSON.parse(localStorage.getItem('BMflavors'));

            if(flavorList !== null && flavorList !== undefined) {
                let flavorObj = undefined;
                try {
                    flavorObj = flavorList.find(item => item.id === flavorId);
                }
                catch(err) {
                    return true;
                }

                if(flavorObj === undefined) {
                    return true;
                }


                if(flavorObj.type == "BM") {
                    return false;

                }
                //localStorage.setItem(flavorId, type + ', ' + processor + 'vCPU, ' + ram + ' RAM, ' + storage + ' NVMe storage')
                return true;
            }
        } catch(e) {

        }
        return true;
    };
    checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while getting user subscription details"

                });
                this.clearToastMessage();
                return;
            }
            if(resp.error) {
                this.setState({
                    isAction: false,
                    isUserSubscribed: true
                });
                this.loadRegionUserNotSubscribed();
            }
            else {

                this.loadRegions();
                this.getAdditionalIpDetails();

            }

        });
    };
    clearToastMessage = () => {
        setTimeout(() => {
            this.setState({
                message: "",
                msgType: ""
            });
        }, 10000);
    };
    loadRegionUserNotSubscribed() {
        RegionService.getAll().then((resp) => {
            if(resp === false) {
                this.setState({ regionListFilter: [], isAction: false });
            }
            if(resp && resp.length > 0) {
                let elem = resp[0];

                this.setState({
                    regions: resp,
                    isregionselected: true,
                    isAction: false,
                    region: elem.id,
                    regionValue: elem.name,
                    countryName: elem.countryName,
                    regionCapacity: elem.capacity
                });
                this.checkRegionForSpeedLink(elem.id);
            } else {
                this.setState({ isAction: false });
            }

        });
    }
    loadRegions = () => {
        let allRegion = [];
        RegionService.getAll().then((resp) => {
            allRegion = resp;
        });

        RegionService.getAllAvailabilityZone().then((resp) => {
            if(resp === false) {
                this.setState({ regionListFilter: [], isAction: false });
            }
            if(resp && resp.length > 0) {

                resp = resp.filter(resp => resp.lbregionstatus === 1);
                let locRegions = resp;
                let elem = resp[0];
                // if(this.state.email===REVIEWER_EMAIL) {
                //     locRegions = resp.filter(item=>item.id===REVIEWER_REGION)
                //     elem = locRegions[0]
                // } else {
                //     elem = resp[0]
                // }

                if(elem.status !== 1) {
                    elem = resp.filter(item => item.status === 1)[0];
                    //locRegions = resp;
                    if(elem === undefined) {
                        locRegions = allRegion;
                        elem = allRegion.filter(item => item.status === 1)[0];
                    }
                }
                this.checkRegionForSpeedLink(elem.id);
                this.setState({
                    region: elem.id, regionValue: elem.name,
                    regions: locRegions, isregionselected: true, countryName: elem.countryName,
                    availabilityZone: elem.availability_zone,
                    regionCapacity: elem.capacity
                }, () => this.getInstanceList(this.state.region));
            } else {
                this.setState({ isAction: false });
            }

        }).catch(error => {
            this.setState({ isAction: false, regionText: false });
        });

    };
    getRegionDropdown = (event) => {
        event.stopPropagation();
        event.preventDefault();
        $(".scrollarea-content").removeAttr("tabindex");
        $(".regionSelect_options").addClass("active");
        $(".region_select_container").addClass("active");
        document.getElementById('regionId').focus();
        console.log(this.state.regions);
        this.setState({ regionListFilter: this.state.regions, isregionselected: false, dropRegion: '' }, () => this.scrollTop());
    };
    scrollTop() {
        if(this.scrollRef && this.scrollRef.current && this.scrollRef.current.scrollArea) {
            this.scrollRef.current.scrollArea.scrollTop();
        }
    }
    getSelectedRegion = (event, regionOb) => {

        let id = regionOb.id; let region = regionOb.name; let countryName = regionOb.countryName.toLowerCase();
        let regionCap = regionOb.capacity;
        if(regionOb.status !== 1) {
            sessionStorage.inFocus = true;
            return;
        }
        sessionStorage.inFocus = false;
        $(".regionSelect_options").removeClass("active");

        $(".region_select_container").removeClass("active");
        if(id === this.state.region) {
            return;
        }
        if(!this.state.isUserSubscribed) {
            let item = this.state.regions.find(elem => elem.region === id);

            this.setState({

                region: id,
                regionValue: region,
                regionCapacity: regionCap
            });

        }
        else {
            let item = this.state.regions.find(elem => elem.region === id);

            this.setState({
                region: id,
                regionValue: region,
                regionCapacity: regionCap
            });
        }
        let zone = this.state.regions.find(elem => elem.id === id);
        if(zone.availability_zone != undefined) {

            this.setState({
                availabilityZone: zone.availability_zone
            });
        }
        if(!this.state.isUserSubscribed) {
            console.log(this.state.regionList);
            let regionpick = this.state.regionList.find(regionItem => regionItem.region === id);

            this.setState({ regionUrl: regionpick.url });
            this.getAttachedInstances(regionpick.url, "afterLoad");
        }
        this.checkRegionForSpeedLink(id);
        this.setState({
            countryName: countryName, errorMessg: '',
            regionErrorMsg: '', isregionselected: true, isCreateDisabled: true
        });
    };
    filterDropDown = (event) => {
        event.stopPropagation();
        event.preventDefault();
        $(".scrollarea-content").removeAttr("tabindex");
        if(this.props.location.state && (this.props.location.state.image || this.props.location.state.instanceOb) && this.props.location.state.regionName) {
            return;
        }
        $(".regionSelect_options").addClass("active");
        let name = event.target.name;
        let val = event.target.value;
        let lcVal = val.toLowerCase();
        let items = this.state.regions.filter(item => item.id.toLowerCase().includes(lcVal) || item.name.toLowerCase().includes(lcVal));
        //let form = this.state.instanceForm
        //form.region = val

        this.setState({ regionListFilter: items, selectedRegionUrl: '', dropRegion: val });
    };
    onFocusOut = (e) => {
        if(!e.currentTarget.contains(e.relatedTarget)) {
            if(sessionStorage.inFocus === true) {
                sessionStorage.inFocus = false;
                return;
            }
            this.setState({ dropRegion: '', isregionselected: true });
            $(".regionSelect_options").removeClass('active');
            $(".region_select_container").removeClass("active");
        }
    };

    onDropArrowClick = () => {
        if($('.regionSelect_options').is('active')) {
            $(".regionSelect_options").addClass("active");
        } else {
            $(".regionSelect_options").removeClass('active');
        }
    };
    enableInstanceOptions = (event) => {
        $(event.currentTarget).closest('.tr').find('.lbinstance_dropdown').toggleClass('active');
    };
    createLoadBalancer = () => {
        if(this.state.isSuspended) return;
        if(this.state.isUserSubscribed) {
            this.setState({
                isRedirectCCPage: true
            });
            return;
        }
        if(this.state.region.length < 1) {
            this.setState({
                message: "Please select a region",
                msgType: "error"
            });
            return;
        }
        if(this.state.loadBalConfigLabel.trim().length <= 0) {
            this.setState({
                labelEmpty: true,
                labelError: false
            });
            this.labelRef.current.focus();
            return;
        }
        if(this.state.loadBalConfigLabel.trim().length > 0) {
            if(!Validate("firstName", this.state.loadBalConfigLabel)) {
                this.setState({
                    labelError: true
                });
                this.labelRef.current.focus();
                return;
            }

        }
        if(this.state.loadBalConfigStickySession === "APP_COOKIE" && this.state.loadBalConfigCookie.trim().length <= 0) {
            this.setState({
                cookieEmpty: true,
                cookieError: false
            });
            this.cookieRef.current.focus();
            return;
        }
        if(this.state.loadBalConfigStickySession === "APP_COOKIE" && this.state.loadBalConfigCookie.trim().length > 0) {
            if(!Validate("firstName", this.state.loadBalConfigCookie)) {
                this.setState({
                    cookieError: true
                });
                this.cookieRef.current.focus();
                return;
            }

        }
        if(this.state.portConfigPort.length <= 0) {
            this.setState({
                portConfigPortEmpty: true,
                portConfigPortError: false
            });
            this.portConPortRef.current.focus();
            return;
        }
        if(this.state.portConfigPort.length > 0) {
            if(!Validate("number", this.state.portConfigPort) || !Validate("notStartWithZero", this.state.portConfigPort)) {
                this.setState({
                    portConfigPortEmpty: false,
                    portConfigPortError: true
                });
                this.portConPortRef.current.focus();
                return;
            }

        }
        if(this.state.portConfigPort < 1 || this.state.portConfigPort > 65535) {
            this.setState({
                portConfigPortEmpty: false,
                portConfigPortError: true
            });
            this.portConPortRef.current.focus();
            return;
        }
        if(this.state.healthChecksMaxRetriesDown.length <= 0) {
            this.setState({
                maxRetriesDownEmpty: true
            });
            this.retiresDownRef.current.focus();
            return;
        }


        if(this.state.healthChecksMaxRetriesDown.length > 0) {
            let val = this.state.healthChecksMaxRetriesDown;
            if(!Validate("noDecimals", Number(this.state.healthChecksMaxRetriesDown)) || val < 1 || val > 10) {
                this.setState({
                    maxRetriesDownError: true
                });
                this.retiresDownRef.current.focus();
                return;
            }
        }
        if(this.state.healthChecksTimeout.length <= 0) {
            this.setState({
                timeOutEmpty: true
            });
            this.timeoutRef.current.focus();
            return;
        }
        if(this.state.healthChecksTimeout.length > 0) {
            let val = this.state.healthChecksTimeout;
            if(!Validate("otp", this.state.healthChecksTimeout)) {
                this.setState({
                    timeOutRegex: true,
                    timeOutError: false

                });
                this.timeoutRef.current.focus();
                return;
            }
            if(Number(val) < 3 || Number(val) > 300) {
                this.setState({
                    timeOutError: true,
                    timeOutRegex: false
                });
                this.timeoutRef.current.focus();
                return;
            }
        }
        if(this.state.healthChecksMaxRetries.length <= 0) {
            this.setState({
                maxRetriesEmpty: true
            });
            this.retiresRef.current.focus();
            return;
        }
        if(this.state.healthChecksMaxRetries.length > 0) {
            let val = this.state.healthChecksMaxRetries;
            if(!Validate("noDecimals", Number(this.state.healthChecksMaxRetries)) || val < 1 || val > 10) {
                this.setState({
                    maxRetriesError: true
                });
                this.retiresRef.current.focus();
                return;
            }
        }
        if(this.state.healthChecksDelay.length <= 0) {
            this.setState({
                delayEmpty: true
            });
            this.delayRef.current.focus();
            return;
        }
        if(this.state.healthChecksDelay.length > 0) {
            let val = this.state.healthChecksDelay;
            if(!Validate("otp", this.state.healthChecksDelay)) {
                this.setState({
                    delayRegex: true,
                    delayError: false

                });
                this.delayRef.current.focus();
                return;
            }
            if(Number(val) < 3 || Number(val) > 300) {
                this.setState({
                    delayError: true,
                    delayRegex: false

                });
                this.delayRef.current.focus();
                return;
            }
        }
        let typeVal = this.state.healthChecksType;
        if((typeVal === "HTTP" || typeVal === "HTTPS") && this.state.healthChecksUrl.length <= 0) {
            this.setState({
                urlEmpty: true,
                urlError: "URL Path cannot be blank"
            });
            this.urlRef.current.focus();
        }

        if(this.state.healthChecksSelectedECodes.length == 0) {
            this.setState({
                ecodeEmpty: true
            });
        }
        if(Number(this.state.healthChecksTimeout) > Number(this.state.healthChecksDelay)) {
            this.setState({
                timeOutError: true,
                timeOutRegex: false
            });
            this.timeoutRef.current.focus();
            return;
        }
        if(Number(this.state.healthChecksDelay) < Number(this.state.healthChecksTimeout)) {
            this.setState({
                delayError: true,
                delayRegex: false

            });
            this.delayRef.current.focus();
            return;
        }
        this.setState({
            isAction: true
        });

        let userId = localStorage.getItem("userId");
        const data = {
            "loadBalConfig": {
                "name": this.state.loadBalConfigLabel.trim(),
                "algorithm": this.state.loadBalConfigAlgorithm,
                "session": this.state.loadBalConfigStickySession,
                "cookieName": this.state.showCookie ? this.state.loadBalConfigCookie.trim() : "none"
            },
            "portConfig": {
                "port": this.state.portConfigPort,
                "protocol": this.state.portConfigProtocol
            },
            "healthChecks": {
                "type": this.state.healthChecksType,
                "maxRetiresDown": this.state.healthChecksMaxRetriesDown,
                "timeout": this.state.healthChecksTimeout,
                "maxRetries": this.state.healthChecksMaxRetries,
                "delay": this.state.healthChecksDelay,
                "httpMethod": this.state.isTypeNotHttpOrHttps ? "" : this.state.healthChecksHttp,
                "statusCode": this.state.isTypeNotHttpOrHttps ? "" : this.state.healthChecksSelectedECodes,
                "urlPath": this.state.isTypeNotHttpOrHttps ? "" : this.state.healthChecksUrl
            },
            "members": this.state.attachInstaneList

        };
        axiosInstance.post(API_HOST + "/loadbal/createloadbalancer/" + userId + "?region=" + this.state.region, { "data": data }, axiosRequestWithAuth)
            .then(resp => {
                if(resp.data && resp.data === "FAILED_TO_CREATE_IP") {
                    this.setState({
                        isAction: false,
                        message: "Resource cannot be allocated at the moment. Try again later.",
                        msgType: "error"
                    });
                    this.clearToastMessage();
                    return;
                }
                if(resp.data && resp.data === "FAILED_TO_CREATE") {
                    this.setState({
                        isAction: false,
                        message: "Error while creating load balancer, please try again after sometime.",
                        msgType: "error"
                    });
                    this.clearToastMessage();
                    return;
                }
                if(resp.data && resp.data === "URL_PATH_ERROR") {
                    this.setState({
                        isAction: false,
                        urlEmpty: true,
                        urlError: "Invalid URL path"
                    });
                    this.urlRef.current.focus();
                    return;
                }
                if(resp === false) {
                    this.setState({
                        isAction: false,
                        message: "Error while creating load balancer, please try again after sometime.",
                        msgType: "error"
                    });
                    this.clearToastMessage();
                    return;
                }
                if(resp === null) {
                    this.setState({
                        isAction: false,
                        message: "Error while creating load balancer, please try again after sometime.",
                        msgType: "error"
                    });
                    this.clearToastMessage();
                    return;
                }
                this.props.history.push("/load-balancers");
            })
            .catch(error => {
                console.log(error);
            });
    };
    setLoadBalConfig = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        if(name === "loadBalConfigLabel") {
            if(val.length <= 0) {
                this.setState({
                    labelEmpty: true,
                    labelError: false
                });
            }
            else {
                this.setState({
                    labelEmpty: false
                });
                if(!Validate("firstName", val)) {
                    this.setState({
                        labelError: true
                    });
                }
                else {
                    this.setState({
                        labelError: false
                    });
                }
            }
        }
        if(name === "loadBalConfigCookie") {
            if(val.length <= 0) {
                this.setState({
                    cookieEmpty: true,
                    cookieError: false
                });
            }
            else {
                this.setState({
                    cookieEmpty: false
                });
                if(!Validate("firstName", val)) {
                    this.setState({
                        cookieError: true
                    });
                }
                else {
                    this.setState({
                        cookieError: false
                    });
                }
            }
        }
        if(name === "loadBalConfigStickySession") {
            if(val === "APP_COOKIE") {
                this.setState({
                    showCookie: true
                });
            }
            else {
                this.setState({
                    showCookie: false
                });
            }
        }
        this.setState({
            [name]: val
        });


    };
    setPortConfig = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        if(name === "portConfigPort") {
            if(val.length <= 0) {
                this.setState({
                    portConfigPortEmpty: true,
                    portConfigPortError: false
                });
            }
            else {


                if(val < 1 || val > 65535) {
                    this.setState({
                        portConfigPortEmpty: false,
                        portConfigPortError: true
                    });
                }
                else {
                    this.setState({
                        portConfigPortEmpty: false,
                        portConfigPortError: false
                    });
                }
            }
        }
        if(name === "portConfigProtocol") {
            if(val === "HTTP") {
                this.setState({
                    portConfigPort: "80"
                });
            }
            else {
                this.setState({
                    portConfigPort: "49152"
                });
            }
        }
        this.setState({
            [name]: val
        });
    };
    setHealthChecks = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        this.setState({
            maxRetriesDownEmpty: false,
            maxRetriesDownError: false,
            delayEmpty: false,
            delayError: false,
            timeOutError: false,
            timeOutEmpty: false,
            maxRetriesEmpty: false,
            maxRetriesError: false
        });
        if(name === "healthChecksMaxRetriesDown") {
            if(val.length <= 0) {
                this.setState({
                    maxRetriesDownEmpty: true,
                    maxRetriesDownError: false
                });
            }
            else {
                this.setState({
                    maxRetriesDownEmpty: false,
                    maxRetriesDownError: false
                });
            }
        }
        if(name === "healthChecksMaxRetries") {
            if(val.length <= 0) {
                this.setState({
                    maxRetriesEmpty: true,
                    maxRetriesError: false
                });
            }
            else {
                this.setState({
                    maxRetriesEmpty: false,
                    maxRetriesError: false
                });
            }
        }
        if(name === "healthChecksType") {
            if(val === "PING" || val === "TCP" || val === "UDP-CONNECT") {
                this.setState({
                    healthChecksUrl: "",
                    healthChecksHttp: "",
                    isTypeNotHttpOrHttps: true
                });
            }
            else {
                this.setState({
                    healthChecksUrl: "/",
                    healthChecksHttp: "GET",
                    isTypeNotHttpOrHttps: false
                });
            }
        }
        if(name === "healthChecksDelay") {
            if(val.length <= 0) {
                this.setState({
                    delayEmpty: true,
                    delayError: false,
                    delayRegex: false
                });
            }
            else {
                this.setState({
                    delayEmpty: false,
                    delayError: false,
                    delayRegex: false
                });

            }
        }
        if(name === "healthChecksTimeout") {
            if(val.length <= 0) {
                this.setState({
                    timeOutEmpty: true,
                    timeOutError: false,
                    timeOutRegex: false
                });
            }
            else {
                this.setState({
                    timeOutEmpty: false,
                    timeOutError: false,
                    timeOutRegex: false
                });


            }
        }
        if(name === "healthChecksUrl") {
            if(val.length <= 0) {
                this.setState({
                    urlEmpty: true,
                    urlError: "URL Path cannot be blank"
                });
            }
            else {
                this.setState({
                    urlEmpty: false
                });
            }
        }

        this.setState({
            [name]: val
        });
    };

    toggleEcodesDropdown() {

        $(".dropdown_component.addedcode_dropdown").toggleClass('active');


    }

    handleCursorExpectedCodes(inputList) {
        if(inputList.length >= 3) {
            $('.tags_container').addClass('tags_wrap');
        }
        else {
            $('.tags_container').removeClass('tags_wrap');
        }
    }

    addOrRemoveExpectedCodes(type, val) {

        if(!this.state.isTypeNotHttpOrHttps) {
            if(type == "add") {
                this.toggleEcodesDropdown();
                let tempRemove = [...this.state.filterECodes];
                tempRemove = tempRemove.filter((item) => val != item);
                let tempAdd = [...this.state.healthChecksSelectedECodes];
                tempAdd.push(val);
                tempAdd.sort();
                this.handleCursorExpectedCodes(tempAdd);
                this.setState({
                    filterECodes: tempRemove,
                    healthChecksSelectedECodes: tempAdd,
                    ecodeEmpty: false
                });
            }
            if(type == "remove") {
                this.toggleEcodesDropdown();
                let tempRemove = [...this.state.healthChecksSelectedECodes];
                tempRemove = tempRemove.filter((item) => val != item);
                let tempAdd = [...this.state.filterECodes];
                tempAdd.push(val);
                tempAdd.sort();
                this.handleCursorExpectedCodes(tempRemove);
                this.setState({
                    filterECodes: tempAdd,
                    healthChecksSelectedECodes: tempRemove,
                    ecodeEmpty: tempRemove.length == 0 ? true : false
                });
            }
        }
    }
    filterCodes = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        let filtered = this.state.expectedCodes.filter(elem => !this.state.healthChecksSelectedECodes.includes(elem));
        if(val.length > 0) {
            filtered = this.state.expectedCodes.filter(elem => elem == val);
        }
        this.setState({
            filterECodes: filtered
        });

    };

    attachInstanceMethod = (event) => {
        let name = event.target.name;
        let val = event.target.value;

        this.setState({
            selectedInstanceId: val,
            instanceEmpty: false,
            instanceError: false
        }, () => {
            this.setState({
                instanceIpAddrs: this.getMainIp(this.state.selectedInstanceId)
            });
        });


    };
    setInstanceInputs = (event) => {
        this.setState({

            intsancePortEmpty: false,
            intsanceWeightEmpty: false,
            instancePortError: false,
            instanceWeightError: false
        });
        let name = event.target.name;
        let val = event.target.value;
        this.setState({
            [name]: val
        });
    };
    attachInstances = (event) => {
        if(this.state.selectedInstanceId === '') {
            this.setState({
                instanceEmpty: true
            });
            return;
        }
        if(this.state.instancePort.length <= 0) {
            this.setState({
                intsancePortEmpty: true,
                instancePortError: false
            });
            return;
        }
        if(this.state.instancePort.length > 0) {
            if(!Validate("number", this.state.instancePort) || !Validate("notStartWithZero", this.state.instancePort)) {
                this.setState({
                    intsancePortEmpty: false,
                    instancePortError: true
                });
                return;
            }

        }
        if(this.state.instancePort < 1 || this.state.instancePort > 65535) {
            this.setState({
                intsancePortEmpty: false,
                instancePortError: true
            });
            return;
        }
        if(this.state.instanceWeight.length <= 0) {
            this.setState({
                intsanceWeightEmpty: true,
                instanceWeightError: false
            });
            return;
        }
        if(this.state.instanceWeight.length > 0) {
            if(!Validate("number", this.state.instanceWeight) || !Validate("notStartWithZero", this.state.instanceWeight)) {
                this.setState({
                    intsanceWeightEmpty: false,
                    instanceWeightError: true
                });
                return;
            }

        }

        if(this.state.instanceWeight < 1 || this.state.instanceWeight > 256) {
            this.setState({
                intsanceWeightEmpty: false,
                instanceWeightError: true
            });
            return;
        }
        let inst = this.state.filteredInstance.filter(elem => elem.instanceId != this.state.selectedInstanceId);
        let obj = {
            "instanceId": this.state.selectedInstanceId,
            "instanceName": this.getInstanceName(this.state.selectedInstanceId),
            "instanceIp": this.state.instanceIpAddrs,
            "port": this.state.instancePort,
            "weight": this.state.instanceWeight
        };
        this.setState({
            attachInstaneList: this.state.attachInstaneList.concat(obj),
            filteredInstance: inst,
            enableAttachInstance: false
        });
        $("body").removeClass("popup_no_scroll");
    };
    getInstanceName = (serverId) => {
        let instances = this.state.filteredInstance;
        let instance = instances.find(elem => elem.instanceId === serverId);
        console.log(instance);
        return instance.instanceName;
    };
    getAttachInstanceName = (serverId) => {
        let instances = this.state.attachInstaneList;
        let instance = instances.find(elem => elem.instanceId === serverId);
        console.log(instance);
        return instance.instanceName;
    };
    editAttachedInstance = (event, serverId) => {
        if(this.state.instancePort.length <= 0) {
            this.setState({
                intsancePortEmpty: true,
                instancePortError: false
            });
            return;
        }
        if(this.state.instancePort.length > 0) {
            if(!Validate("number", this.state.instancePort) || !Validate("notStartWithZero", this.state.instancePort)) {
                this.setState({
                    intsancePortEmpty: false,
                    instancePortError: true
                });
                return;
            }

        }
        if(this.state.instancePort < 1 || this.state.instancePort > 65535) {
            this.setState({
                intsancePortEmpty: false,
                instancePortError: true
            });
            return;
        }
        if(this.state.instanceWeight.length <= 0) {
            this.setState({
                intsanceWeightEmpty: true,
                instanceWeightError: false
            });
            return;
        }
        if(this.state.instanceWeight.length > 0) {
            if(!Validate("number", this.state.instanceWeight) || !Validate("notStartWithZero", this.state.instanceWeight)) {
                this.setState({
                    intsanceWeightEmpty: false,
                    instanceWeightError: true
                });
                return;
            }

        }

        if(this.state.instanceWeight < 1 || this.state.instanceWeight > 256) {
            this.setState({
                intsanceWeightEmpty: false,
                instanceWeightError: true
            });
            return;
        }
        let instList = this.state.attachInstaneList.filter(elem => elem.instanceId != serverId);
        let obj = {
            "instanceId": this.state.selectedInstanceId,
            "instanceName": this.getAttachInstanceName(this.state.selectedInstanceId),
            "instanceIp": this.state.instanceIpAddrs,
            "port": this.state.instancePort,
            "weight": this.state.instanceWeight
        };
        this.setState({
            attachInstaneList: instList.concat(obj),
            enableEditInstance: false
        });
        $("body").removeClass("popup_no_scroll");
    };
    detachAttchedInstance = (e) => {
        let instList = this.state.attachInstaneList.filter(elem => elem.instanceId != this.state.detachInstanceId);
        let instance = this.state.instanceList.find(elem => elem.instanceId === this.state.detachInstanceId);
        let fixData = {
            "instanceId": instance.instanceId,
            "instanceName": instance.instanceName,
            "instanceAddrss": instance.instanceAddrss
        };
        this.setState({
            attachInstaneList: instList,
            filteredInstance: this.state.filteredInstance.concat(fixData),
            detachInstance: false
        });
        $('body').removeClass("popup_no_scroll");
    };
    validateField(evt) {
        var theEvent = evt || window.event;

        // Handle paste
        if(theEvent.type === 'paste') {
            key = evt.clipboardData.getData('text/plain');
        } else {
            // Handle key press
            var key = theEvent.keyCode || theEvent.which;
            key = String.fromCharCode(key);
        }
        var regex = /[0-9]|\./;
        if(!regex.test(key)) {
            theEvent.returnValue = false;
            if(theEvent.preventDefault) theEvent.preventDefault();
        }
    }

    convertToCamelCase = (str) => {
        return str.split(/[ ,_-]+/).map(function (word, index) {
            if(word === "IP" || word === "UDP")
                return word;
            return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }).join(' ');
    };

    render() {
        if(this.state.isRedirectCCPage) {
            return <Redirect to={ {
                pathname: "/billing/creditcard",
                state: { message: true }
            } }></Redirect>;
        }
        let arr = this.state.algorithmList;
        return (
            <div className="main_nav_module createLb_module">
                <main>
                    <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <LeftNav isActive={ 'loadbal' }></LeftNav>

                    <div className="main_container">
                        <header className="header_wrap">
                            <HeaderTop showCreate={ true } isUserSubscribed={ this.state.isUserSubscribed }></HeaderTop>
                            <div className="header_wrap_bottom">
                                <div className="bottom_navbar">
                                    <div className="bn_left">
                                        <span className="bck_icon" data-tip data-for="backBtn" currentitem="false" onClick={ () => this.props.history.push("/load-balancers") }>
                                            <span className="svg_wrap">➔</span>
                                        </span><ReactToolTip id="backBtn" place="right" effect='solid'>Back to load balancers list page</ReactToolTip>
                                        <div className="title_txt">Load Balancer <span className="title_info"></span> </div>
                                    </div>
                                </div>
                            </div>
                        </header>
                        <NotificationSlider />
                        <section className="main_section">
                            <div className="main_body_container">
                                <div className="mainBody_colWrap">
                                    <div className="loadBalance_container">
                                        <section className="lb_regionBlk">
                                            <h3>Select a Region</h3>
                                            <span className="error_msg" style={ { display: "none" } }>Please select a region</span>
                                            <div className="inp_row no_label">
                                                <div className="common_txtBox_row region_select" onBlur={ (e) => this.onFocusOut(e) }>
                                                    <div className="region_select_container">
                                                        <div className="slectBox" onClick={ (e) => this.getRegionDropdown(e) } >
                                                            <div className={ this.state.isregionselected ? "search_inp_box optSelect" : "search_inp_box optUnselect" }>
                                                                <textarea id="regionId" name="region" value={ this.state.dropRegion } placeholder="Select a Region" onChange={ this.filterDropDown } autoComplete="off"></textarea>
                                                            </div>
                                                            <ul>
                                                                <li className="selected_elem" style={ { display: this.state.regionText ? "" : "none" } }><span className={ "country_flag " + this.state.countryName.toLowerCase() }></span>{ this.state.regionValue } ({ this.state.region })
                                                                    <span className={ Number(this.state.regionCapacity) < 20 ? "vcpu_value limited" : "vcpu_value available" }>{ this.state.regionCapacity }%<i></i> { Number(this.state.regionCapacity) < 20 ? "Limited Capacity" : "Capacity Available" }</span>
                                                                </li>
                                                            </ul>
                                                            <span className="dropArrow" > <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                                <title>drop-down</title>
                                                                <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                                            </svg>
                                                            </span>
                                                            <span className="vcpu_label" style={ { display: this.state.isBmr ? "none" : "" } }>Capacity</span>
                                                        </div>
                                                        <div className="regionSelect_options" style={ { maxHeight: "inherit", overflowY: "inherit" } }>
                                                            <ScrollArea ref={ this.scrollRef }
                                                                speed={ 0.8 }
                                                                style={ { maxHeight: "245px" } }
                                                                vertical={ true }
                                                                horizontal={ false }
                                                                minScrollSize={ 10 }
                                                                smoothScrolling={ true }
                                                                verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: "1", } }
                                                                verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: "1" } }
                                                                stopScrollPropagation={ true }


                                                            >

                                                                { this.state.regionListFilter.length <= 0 ?

                                                                    <ul className="noSearchRes" style={ { display: this.state.regionListFilter.length <= 0 && !this.state.isregionselected ? "" : "none" } }>
                                                                        <li>No matching region found</li>
                                                                    </ul>

                                                                    :

                                                                    <ul>

                                                                        { this.state.regionListFilter.map((region, i) =>
                                                                            <li className={ "option_elem " + region.statusClass } key={ i } onMouseDown={ (e) => this.getSelectedRegion(e, region) } disabled={ region.status !== 1 }><span className={ 'country_flag ' + region.countryName.toLowerCase() } ></span>{ region.name } ({ region.id })
                                                                                <span style={ { display: region.status != 1 ? "none" : "" } } className={ Number(region.capacity) < 20 ? "vcpu_value limited" : "vcpu_value available" }>{ region.capacity }%<i></i> { Number(region.capacity) < 20 ? "Limited Capacity" : "Available" }</span>
                                                                                <span className="algin_right__arrow" style={ { display: region.status === 1 ? 'none' : '' } }>{ region.statusName }</span>
                                                                            </li>
                                                                        ) }

                                                                    </ul>
                                                                }
                                                            </ScrollArea>
                                                        </div>
                                                    </div>
                                                </div>
                                                <a href={ this.state.setLink } className="speedTest_link" style={ { display: this.state.showSpeed ? "" : "none" } } target="_blank">Perform Network Speed Test for this Region</a>
                                                <a data-tip data-for="speedlink" href={ this.state.setLink } className="speedTest_link speedTest_btn" style={ { display: this.state.showSpeed ? "" : "none" } } target="_blank">Perform Network Speed Test for this Region</a>
                                                <ReactToolTip id="speedlink" place="top" effect='solid'>Perform Network Speed Test for this Region</ReactToolTip>
                                            </div>
                                        </section>
                                        <div className="config_blks lb_config">
                                            <div className="config_blks_cont">
                                                <div className="field_sec_wrap">
                                                    <h3>Load Balancer Configuration
                                                        <span className="question_icon" data-tip data-for="loadConfig">
                                                            <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                                <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                            </svg>
                                                        </span><ReactToolTip id="loadConfig" effect='solid' place='right'>
                                                            Configure load balancer settings<br></br> to route connection requests to<br></br> the attached instances
                                                        </ReactToolTip>
                                                    </h3>
                                                    <p>Select the required network port and protocal for load balancing</p>
                                                    <div className="field_wrap">
                                                        <div className="common_txtBox_row">
                                                            <label>Label</label>
                                                            <input type="text" ref={ this.labelRef } id="labelRef" autoComplete="off" maxLength="20" name="loadBalConfigLabel" className="txtBox" placeholder="Name of load balancer" onChange={ (event) => this.setLoadBalConfig(event) } />
                                                            <span className="err_msg" style={ { display: this.state.labelEmpty ? "" : "none" } }>Label cannot be blank</span>
                                                            <span className="err_msg" style={ { display: this.state.labelError ? "" : "none" } } >Label can contain a-z, A-Z,-,_ and space</span>
                                                        </div>
                                                        <div className="common_txtBox_row">
                                                            <label>Algorithm</label>
                                                            <div className="custom_select_box coutry_code_wrap">
                                                                <select name="loadBalConfigAlgorithm" value={ this.state.loadBalConfigAlgorithm } id="algorithm" onChange={ (event) => this.setLoadBalConfig(event) }>
                                                                    {
                                                                        this.state.algorithmList.map((algo, idx) => (
                                                                            <option key={ idx } value={ algo }>{ this.convertToCamelCase(algo.trim()) }</option>
                                                                        ))
                                                                    }

                                                                </select>
                                                            </div>
                                                            <span className="err_msg" style={ { display: "none" } }>First Name cannot be blank</span>
                                                            <span className="err_msg" style={ { display: "none" } }>First name can contain a-z, A-Z and space</span>
                                                        </div>
                                                        <div className="common_txtBox_row">
                                                            <label>Sticky Session</label>
                                                            <div className="custom_select_box coutry_code_wrap">
                                                                <select name="loadBalConfigStickySession" value={ this.state.loadBalConfigStickySession } id="algorithm" onChange={ (event) => this.setLoadBalConfig(event) }>
                                                                    {
                                                                        this.state.sessionTypes.map((session, idx) => (
                                                                            <option key={ idx } value={ session }>{ this.convertToCamelCase(session.trim()) }</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                            <span className="err_msg" style={ { display: "none" } }>First Name cannot be blank</span>
                                                            <span className="err_msg" style={ { display: "none" } }>First name can contain a-z, A-Z and space</span>
                                                        </div>
                                                        <div className="common_txtBox_row" style={ { display: this.state.showCookie ? "block" : "none" } }>
                                                            <label>Cookie Name</label>
                                                            <input type="text" ref={ this.cookieRef } autoComplete="off" maxLength="20" name="loadBalConfigCookie" className="txtBox" placeholder="Name of session cookie" onChange={ (event) => this.setLoadBalConfig(event) } />
                                                            <span className="err_msg" style={ { display: this.state.cookieEmpty ? "" : "none" } }>Cookie name cannot be blank</span>
                                                            <span className="err_msg" style={ { display: this.state.cookieError ? "" : "none" } } >Cookie name can contain a-z, A-Z,-,_ and space</span>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="config_blks lb_config">
                                            <div className="config_blks_cont">
                                                <div className="field_sec_wrap">
                                                    <h3>Port Configuration
                                                        <span className="question_icon" data-tip data-for="portConfig">
                                                            <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                                <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                            </svg>
                                                        </span><ReactToolTip id="portConfig" place='right' effect="solid">
                                                            The selected port must match<br></br> the port used on the attached instances
                                                        </ReactToolTip>
                                                    </h3>
                                                    <p>Add a port that the load balancer will listen on</p>
                                                    <div className="field_wrap">
                                                        <div className="common_txtBox_row">
                                                            <label>Port</label>
                                                            <input type="text" ref={ this.portConPortRef } autoComplete="off" maxLength="20" name="portConfigPort" className="txtBox" placeholder="80" value={ this.state.portConfigPort } onChange={ (event) => this.setPortConfig(event) } onKeyPress={ (event) => this.validateField(event) } />
                                                            <span className="err_msg" style={ { display: this.state.portConfigPortEmpty ? "" : "none" } }>Port cannot be blank</span>
                                                            <span className="err_msg" style={ { display: this.state.portConfigPortError ? "" : "none" } } >Port range should be between 1 and 65535</span>
                                                        </div>
                                                        <div className="common_txtBox_row">
                                                            <label>Protocol</label>
                                                            <div className="custom_select_box coutry_code_wrap">
                                                                <select name="portConfigProtocol" value={ this.state.portConfigProtocol } id="algorithm" onChange={ (event) => this.setPortConfig(event) }>
                                                                    {
                                                                        this.state.protocols.map((proto, idx) => (
                                                                            <option key={ idx } value={ proto }>{ this.convertToCamelCase(proto) }</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                            <span className="err_msg" style={ { display: "none" } }>First Name cannot be blank</span>
                                                            <span className="err_msg" style={ { display: "none" } }>First name can contain a-z, A-Z and space</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="config_blks lb_config">
                                            <div className="config_blks_cont">
                                                <div className="field_sec_wrap">
                                                    <h3>Health Checks
                                                        <span className="question_icon" data-tip data-for="healthChecks">
                                                            <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                                <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                            </svg>
                                                        </span>
                                                        <ReactToolTip id="healthChecks" place='right' effect='solid'>
                                                            The load balancer will periodically<br></br> check the status of the attached instances as connection<br></br> requests are routed only to healthy instances
                                                        </ReactToolTip>
                                                    </h3>
                                                    <p>Add a health check route to the attached instances</p>
                                                    <div className="field_wrap">
                                                        <div className="common_txtBox_row">
                                                            <label>Type</label>
                                                            <div className="custom_select_box coutry_code_wrap">
                                                                <select name="healthChecksType" value={ this.state.healthChecksType } id="algorithm" onChange={ (event) => this.setHealthChecks(event) }>
                                                                    {
                                                                        this.state.healthChecks.map((health, idx) => (
                                                                            <option key={ idx } value={ health }>{ this.convertToCamelCase(health.trim()) }</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                            <span className="err_msg" style={ { display: "none" } }>First Name cannot be blank</span>
                                                        </div>
                                                        <div className="common_txtBox_row">
                                                            <label>Max Retries Down</label>
                                                            <input type="text" ref={ this.retiresDownRef } autoComplete="off" name="healthChecksMaxRetriesDown" className="txtBox" placeholder="" value={ this.state.healthChecksMaxRetriesDown } onChange={ (event) => this.setHealthChecks(event) } onKeyPress={ (event) => this.validateField(event) } />
                                                            <span className="err_msg" style={ { display: this.state.maxRetriesDownEmpty ? "" : "none" } }>Max retries down cannot be blank</span>
                                                            <span className="err_msg" style={ { display: this.state.maxRetriesDownError ? "" : "none" } }>Max retries down should be in the range of 1 and 10</span>
                                                        </div>
                                                        <div className="common_txtBox_row">
                                                            <label>Timeout(sec)</label>
                                                            <input type="text" ref={ this.timeoutRef } autoComplete="off" name="healthChecksTimeout" className="txtBox" placeholder="" value={ this.state.healthChecksTimeout } onChange={ (event) => this.setHealthChecks(event) } onKeyPress={ (event) => this.validateField(event) } />
                                                            <span className="err_msg" style={ { display: this.state.timeOutEmpty ? "" : "none" } }>Timeout cannot be blank</span>
                                                            <span className="err_msg" style={ { display: this.state.timeOutError ? "" : "none" } }>Timeout range must be in between 3 and 300 and less than or equal to the delay.</span>
                                                            <span className="err_msg" style={ { display: this.state.timeOutRegex ? "" : "none" } }>Enter a valid input.</span>
                                                        </div>
                                                    </div>
                                                    <div className="field_wrap">
                                                        <div className="common_txtBox_row">
                                                            <label>Max Retries</label>
                                                            <input type="text" ref={ this.retiresRef } autoComplete="off" name="healthChecksMaxRetries" className="txtBox" placeholder="" value={ this.state.healthChecksMaxRetries } onChange={ (event) => this.setHealthChecks(event) } onKeyPress={ (event) => this.validateField(event) } />
                                                            <span className="err_msg" style={ { display: this.state.maxRetriesEmpty ? "" : "none" } }>Max retries cannot be blank</span>
                                                            <span className="err_msg" style={ { display: this.state.maxRetriesError ? "" : "none" } }>Max retries should be in the range of 1 and 10</span>
                                                        </div>
                                                        <div className="common_txtBox_row">
                                                            <label>Delay(sec)</label>
                                                            <input type="text" ref={ this.delayRef } autoComplete="off" name="healthChecksDelay" className="txtBox" placeholder="" value={ this.state.healthChecksDelay } onChange={ (event) => this.setHealthChecks(event) } onKeyPress={ (event) => this.validateField(event) } />
                                                            <span className="err_msg" style={ { display: this.state.delayEmpty ? "" : "none" } }>Delay cannot be blank</span>
                                                            <span className="err_msg" style={ { display: this.state.delayError ? "" : "none" } }>Delay range must be in between 3 and 300 and greater than or equal to timeout.</span>
                                                            <span className="err_msg" style={ { display: this.state.delayRegex ? "" : "none" } }>Enter a valid input.</span>
                                                        </div>
                                                        <div className="common_txtBox_row" style={ { display: this.state.isTypeNotHttpOrHttps ? "none" : "" } }>
                                                            <label>HTTP Methods</label>
                                                            <div className="custom_select_box coutry_code_wrap">
                                                                <select name="healthChecksHttp" value={ this.state.healthChecksHttp } id="algorithm" onChange={ (event) => this.setHealthChecks(event) } disabled={ this.state.isTypeNotHttpOrHttps }>
                                                                    <option value="" style={ { display: this.state.healthChecksType === "HTTP" || this.state.healthChecksType === "HTTPS" ? "none" : "" } }>NONE</option>
                                                                    {
                                                                        this.state.httpMethods.map((http, idx) => (
                                                                            <option key={ idx } value={ http } disabled={ this.state.healthChecksType === "PING" || this.state.healthChecksType === "TCP" || this.state.healthChecksType === "UDP-CONNECT" }>{ this.convertToCamelCase(http.trim()) }</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                            </div>
                                                            <span className="err_msg" style={ { display: "none" } }>First Name cannot be blank</span>
                                                        </div>
                                                    </div>
                                                    <div className="field_wrap" style={ { display: this.state.isTypeNotHttpOrHttps ? "none" : "" } }>
                                                        <div className="common_txtBox_row">
                                                            <label>Expected Codes</label>
                                                            <div className="custom_selectBox expCode_blk">
                                                                <div className="added_applyInstance">
                                                                    <ul className="tags_container" onClick={ (e) => { this.toggleEcodesDropdown(); } }>
                                                                        { this.state.healthChecksSelectedECodes.map((code, index) =>
                                                                            <li key={ index }  >
                                                                                <div className="source_tag">
                                                                                    <div className="row_wrap">
                                                                                        <span className="row row_head">{ code }</span>
                                                                                    </div>
                                                                                    <span className="close_icon" title="Close" onClick={ () => this.addOrRemoveExpectedCodes("remove", code) }></span>
                                                                                </div>
                                                                            </li>
                                                                        ) }
                                                                        <span className="inp_box">
                                                                            <input id="inpSearch" type="hidden" name="inpSearch" className="input_search" autoComplete="off" onChange={ (e) => this.filterCodes(e) } disabled={ this.state.isTypeNotHttpOrHttps } readOnly />
                                                                        </span>
                                                                    </ul>
                                                                    <div className="dropdown_component addedcode_dropdown">
                                                                        { this.state.filterECodes.length > 0 ?
                                                                            <ul>
                                                                                { this.state.filterECodes.map((code, index) =>
                                                                                    <li key={ index } onClick={ () => this.addOrRemoveExpectedCodes("add", code) }>
                                                                                        <span className="code_value">{ code }</span>
                                                                                    </li>
                                                                                ) }
                                                                            </ul>
                                                                            :
                                                                            <li>No codes available to apply</li> }
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <span className="err_msg" style={ { "display": this.state.ecodeEmpty ? "block" : "none" } }>Select atleast one expected code</span>
                                                        </div>
                                                        <div className="common_txtBox_row">
                                                            <label>URL Path</label>
                                                            <input type="text" ref={ this.urlRef } autoComplete="off" name="healthChecksUrl" className="txtBox" placeholder="" value={ this.state.healthChecksUrl } onChange={ (event) => this.setHealthChecks(event) } disabled={ this.state.isTypeNotHttpOrHttps } />
                                                            <span className="err_msg" style={ { display: this.state.urlEmpty ? "" : "none" } }>{ this.state.urlError }</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="lb_instanceTable">
                                            <div className="lb_instanceTable_head">
                                                <h3>Attach Instance
                                                    <span className="question_icon" data-tip data-for="attachText">
                                                        <svg x="0px" y="0px" viewBox="0 0 22 20" enableBackground="new 0 0 22 20" xmlSpace="preserve">
                                                            <path fillRule="evenodd" clipRule="evenodd" fill="#89A2BE" d="M11,1c5,0,9,4,9,9s-4,9-9,9c-5,0-9-4-9-9S6,1,11,1z"></path>
                                                            <text transform="matrix(1 0 0 1 7.0724 15.4681)" fill="#FFFFFF" fontFamily="'Roboto-Medium'" fontSize="16px">?</text>
                                                        </svg>
                                                    </span><ReactToolTip id="attachText" place='right' effect="solid">
                                                        The incoming network traffic<br></br> load of the selected instance<br></br> will be evenly distributed <br></br>among other instances attached<br></br> to the load balancer for faster performance
                                                    </ReactToolTip>
                                                </h3>
                                                <p>Attach an instance to the load balancer</p>
                                                <div className="btn_wrap">
                                                    <input type="button" name="" className="common_cta_btn attach_instBtn" value="Attach Instance" onClick={ () => this.enableInstanceOperations("attach", "open", "") } />
                                                </div>
                                            </div>
                                            <div className="tabular_data_wrap">
                                                <div className="table_header">
                                                    <ul>
                                                        <li className="th">
                                                            <div className="col col1"><div className="">Name<span style={ { display: "none" } } className="sort_icon"></span></div></div>
                                                            <div className="col col2"><div className="">IP Address<span style={ { display: "none" } } className="sort_icon"></span></div></div>
                                                            <div className="col col3"><div className="">Port<span style={ { display: "none" } } className="sort_icon"></span></div></div>
                                                            <div className="col col4"><div className="">Weight<span style={ { display: "none" } } className="sort_icon"></span></div></div>
                                                            <div className="col col5">Actions</div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="table_data">
                                                    <ul>
                                                        { this.state.attachInstaneList.length <= 0 ?
                                                            <li class="tr table_data_empty">
                                                                <div class="outer_empty_wrap">
                                                                    <div class="inner_empty_wrap">
                                                                        <div class="svg_wrap empty_icon lb_instance_empty"></div>
                                                                        <p class="empty_title">No instances found</p>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                            :
                                                            this.state.attachInstaneList.map((instance, index) =>
                                                                <li className="tr" key={ index }>
                                                                    <div className="col col1">
                                                                        <span data-for={ instance.instanceIp } data-tip> { instance.instanceName }</span>
                                                                        { instance.instanceName.length > 30 ?
                                                                            <ReactToolTip id={ instance.instanceIp } place="top" effect='solid'>{ instance.instanceName }</ReactToolTip> : ""
                                                                        }
                                                                    </div>
                                                                    <div className="col col2">{ instance.instanceIp }</div>
                                                                    <div className="col col3">{ instance.port }</div>
                                                                    <div className="col col4">{ instance.weight }</div>
                                                                    <div className="col col5"><span className="icon menu_icon" onClick={ (e) => this.enableInstanceOptions(e, instance) }> <svg className="horizMenuIcon" x="0px" y="0px" viewBox="0 0 22.1 6.3" enableBackground="new 0 0 22.1 6.3" xmlSpace="preserve">
                                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#8692B0" d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                                                    </svg>
                                                                        <ul className="dropdown_component lbinstance_dropdown">
                                                                            <span className="arrow_pointer"></span>
                                                                            <li className="edit" onClick={ () => this.enableInstanceOperations("edit", "open", instance) }>
                                                                                <span className="icon">
                                                                                    <svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve"><path fillRule="evenodd" clipRule="evenodd" fill="#909AAA" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path></svg>
                                                                                </span>Edit</li>
                                                                            <li className="detach" onClick={ () => this.enableInstanceOperations("detach", "open", instance) }>
                                                                                <span className="icon">
                                                                                    <svg x="0px" y="0px" viewBox="0 0 18.6 18.6" enableBackground="new 0 0 18.6 18.6" xmlSpace="preserve"><g><path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M5.2,13.9c1.2,1.2,2.7,1.3,4,0l1.3-1.3l-1.3-1.3l-1.3,1.3   c-0.6,0.5-0.8,0.5-1.3,0c-0.5-0.5-0.6-0.8,0-1.3l1.3-1.3L6.5,8.6L5.2,9.9C3.9,11.2,4,12.7,5.2,13.9z"></path><polygon fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" points="15.2,13.2 17.9,10.6 16.5,9.3 13.9,11.9  "></polygon><path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M7.3,5.2l1.9-1.9C10.5,2,12.8,1.5,14,2.7c1.2,1.2,0.5,3.3-0.8,4.5   l-2,1.9l1.3,1.3l2-1.9c2-2,2.6-5.3,0.8-7.2C13.4-0.5,9.9,0,7.9,2L5.9,3.9L7.3,5.2z"></path><polygon fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" points="11.2,4 8.6,6.6 9.9,7.9 12.5,5.3  "></polygon><path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M11.9,13.9l-1.3,1.3c-2,2-4.8,1.9-6.7,0c-1.9-1.9-2-4.6,0-6.6   l1.3-1.3L3.9,5.9l-1,1C0.1,9.7,0,14,2.5,16.5c2.6,2.6,6.9,2.4,9.7-0.3l1-1L11.9,13.9z"></path></g><rect x="7.8" y="1.5" transform="matrix(0.7071 -0.7071 0.7071 0.7071 -4.946 9.1295)" fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" width="1.5" height="18"></rect></svg>
                                                                                </span>Detach
                                                                            </li>
                                                                        </ul>
                                                                    </span></div>
                                                                </li>
                                                            ) }
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="btn-blk">
                                            <input type="submit" data-tip data-for="createLoadBalancerBtn" className={ this.state.isSuspended ? "common_cta_btn blue disabled" : "common_cta_btn blue" } value="Create" onClick={ () => this.createLoadBalancer() } />
                                            <ReactTooltip id="createLoadBalancerBtn" place='left' effect='solid' disable={ !this.state.isSuspended }>Account suspended. Insufficient privileges to create load balancer.</ReactTooltip>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="unit_summary_rhs">
                                <div className="head_block">Load Balancer Summary</div>
                                <div className="summary_list">
                                    <ul>
                                        <li>
                                            <h4>Region</h4>
                                            <div className="summary_info" >{ this.state.regionValue } ({ this.state.region })</div>
                                        </li>
                                        <li>
                                            <h4>Name</h4>
                                            <div className="summary_info">{ this.state.loadBalConfigLabel }</div>
                                        </li>
                                    </ul>
                                    <div className="total_amt">${ this.state.lbCost }/month</div>
                                    <input type="button" data-tip data-for="createLoadBalancerBtn_vm" value="Create" className={ this.state.isSuspended ? "common_cta_btn blue create_vm_btn disabled" : "common_cta_btn blue create_vm_btn" } onClick={ () => this.createLoadBalancer() } />
                                    <ReactTooltip id="createLoadBalancerBtn_vm" place='top' effect='solid' disable={ !this.state.isSuspended }>Account suspended. Insufficient privileges to create load balancer.</ReactTooltip>
                                </div>
                            </div>
                        </section>
                        {/* Attach instance Slider -->*/ }
                        <div className={ this.state.enableAttachInstance ? "main_slider attach_instance_slider active" : "main_slider attach_instance_slider" }>
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" data-for="attachClose" data-tip onClick={ () => this.enableInstanceOperations("attach", "close", "") }></div>
                                    <ReactToolTip id="attachClose" place='left' effect='solid'>Close</ReactToolTip>
                                    <div className="attach_instance_slide_wrap">
                                        <div className="head_block">
                                            <h2>
                                                <span className="icon_img"><span className="icon"></span></span>Attach Instance</h2>
                                        </div>
                                        <div className="content_wrap">
                                            <p>The incoming network traffic load of the selected instance will be evenly distributed among other instances attached to the load balancer for faster performance.</p>
                                            <div className="common_txtBox_row">
                                                <label>Name</label>
                                                <div className="custom_select_box">
                                                    <select name="instanceAttacher" ref={ this.attachSelect } value={ this.state.selectedInstanceId } className="txt_box" onChange={ (e) => this.attachInstanceMethod(e) }>
                                                        { this.state.filteredInstance.length === 0 ? <option value='' default>No instance available</option> : <option value='' style={ { display: "none" } } default>Select an instance to attach</option> }
                                                        {
                                                            this.state.filteredInstance.length > 0 && this.state.filteredInstance.map((instance, key) =>
                                                                <option key={ key } value={ instance.instanceId } >{ instance.instanceName }</option>
                                                            )
                                                        }

                                                    </select>
                                                </div>
                                                <span className="err_msg" style={ { display: this.state.instanceEmpty ? "" : "none" } }>Select any instance</span>
                                                <span className="err_msg" style={ { display: this.state.instanceError ? "" : "none" } }>Selected instance already exists</span>
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>IPv4 Address</label>
                                                <input type="text" name="instanceIpAddrs" value={ this.state.instanceIpAddrs } className="txt_box" disabled={ true } />
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>Port</label>
                                                <input type="text" autoComplete='off' name="instancePort" value={ this.state.instancePort } className="txt_box" onChange={ (e) => this.setInstanceInputs(e) } onKeyPress={ (event) => this.validateField(event) } />
                                                <span className="err_msg" style={ { display: this.state.intsancePortEmpty ? "" : "none" } }>Port cannot be blank </span>
                                                <span className="err_msg" style={ { display: this.state.instancePortError ? "" : "none" } }>Port should be between 1 and 65535 </span>
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>Weight</label>
                                                <input type="text" autoComplete='off' name="instanceWeight" value={ this.state.instanceWeight } className="txt_box" onChange={ (e) => this.setInstanceInputs(e) } onKeyPress={ (event) => this.validateField(event) } />
                                                <span className="err_msg" style={ { display: this.state.intsanceWeightEmpty ? "" : "none" } }>Weight cannot be blank </span>
                                                <span className="err_msg" style={ { display: this.state.instanceWeightError ? "" : "none" } }>Weight should be between 1 and 256 </span>
                                            </div>
                                            <div className="cta_wrap">
                                                <input type="button" name="" className="common_cta_btn blue" value="Attach" onClick={ (e) => this.attachInstances(e) } />
                                                <input type="button" name="" className="common_cta_btn transparentGrey" value="Cancel" onClick={ () => this.enableInstanceOperations("attach", "close", "") } />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Attach Instance Slider Ends-->*/ }
                        {/*detach Instance slider Statrts*/ }
                        <div className={ this.state.enableEditInstance ? "main_slider edit_instance_slider active" : "main_slider edit_instance_slider" }>
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" data-for="editClose" data-tip onClick={ () => this.enableInstanceOperations("edit", "close", "") }></div>
                                    <ReactToolTip id="editClose" place='left' effect='solid'>Close</ReactToolTip>
                                    <div className="edit_instance_slide_wrap">
                                        <div className="head_block">
                                            <h2>
                                                <span className="icon_img">
                                                    <span className="icon">
                                                        <svg x="0px" y="0px" width="19.6px" height="16.5px" viewBox="0 0 19.6 16.5" enableBackground="new 0 0 19.6 16.5" xmlSpace="preserve"><path fillRule="evenodd" clipRule="evenodd" fill="#ffffff" d="M16.2,5.5l-0.7,0.7l-0.7,0.7l-6.2,6.8h5.2c0.6,0,1,0.4,1,1  s-0.4,1-1,1h-10l0,0h-1v-4l7.8-9L11.3,2L12,1.3c0.8-0.8,2-0.8,2.8,0l1.4,1.4C17,3.5,17,4.8,16.2,5.5z M11.7,4.5L5.1,12  c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l6.6-7.6L11.7,4.5z"></path></svg>
                                                    </span>
                                                </span>Edit Instance</h2>
                                        </div>
                                        <div className="content_wrap">
                                            <p >The incoming network traffic load of the selected instance will be evenly distributed among other instances attached to the load balancer for faster performance.</p>
                                            <div className="common_txtBox_row">
                                                <label>Name</label>
                                                <input type="text" name="allInstance" value={ this.state.instanceName } className="txt_box" disabled={ true } />
                                                {/* <div className="custom_select_box">
                                                    <select name="allInstance" value={ this.state.selectedInstanceId } className="txt_box">
                                                        <option value={ this.state.selectedInstanceId }>{ this.state.instanceName }</option>
                                                    </select>
                                                </div> */}
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>IPv4 Address</label>
                                                <input type="text" name="instanceIpAddrs" value={ this.state.instanceIpAddrs } className="txt_box" disabled={ true } />
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>Port</label>
                                                <input type="text" name="instancePort" value={ this.state.instancePort } className="txt_box" onChange={ (e) => this.setInstanceInputs(e) } onKeyPress={ (event) => this.validateField(event) } />
                                                <span className="err_msg" style={ { display: this.state.intsancePortEmpty ? "" : "none" } }>Port cannot be blank </span>
                                                <span className="err_msg" style={ { display: this.state.instancePortError ? "" : "none" } }>Port should be between 1 and 65535 </span>
                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>Weight</label>
                                                <input type="text" name="instanceWeight" value={ this.state.instanceWeight } className="txt_box" onChange={ (e) => this.setInstanceInputs(e) } onKeyPress={ (event) => this.validateField(event) } />
                                                <span className="err_msg" style={ { display: this.state.intsanceWeightEmpty ? "" : "none" } }>Weight cannot be blank </span>
                                                <span className="err_msg" style={ { display: this.state.instanceWeightError ? "" : "none" } }>Weight should be between 1 and 256 </span>
                                            </div>
                                            <div className="cta_wrap">
                                                <input type="button" name="" className="common_cta_btn blue" value="Save changes" onClick={ (e) => this.editAttachedInstance(e, this.state.selectedInstanceId) } />
                                                <input type="button" name="" className="common_cta_btn transparentGrey" value="Cancel" onClick={ () => this.enableInstanceOperations("edit", "close", "") } />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*detach Instance slider Emds*/ }
                    </div>
                </main>
                {/*Delete Sshkey*/ }
                <div className="main_popup delete_loadBalance_popup">
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon"
                                data-for="detachClose" data-tip></span>
                                <ReactToolTip id="detachClose" place='top' effect='solid'>Close</ReactToolTip>
                                <div className="popup_header">
                                    <div className="sub_title"> Delete</div>
                                </div>
                                <div className="popup_body">
                                    <p>Are you sure you want to delete the load balancer?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <div className="btn btn_confirm">Delete</div>
                                        <div className="btn btn_cancel">Cancel</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End of delete SSH key */ }
                <div className={ this.state.detachInstance ? "main_popup detach_instance_popup active" : "main_popup detach_instance_popup" }>
                    <div className="main_popup_wrapper">
                        <div className="main_popup_bg_shadow"></div>
                        <div className="main_popup__inner">
                            <div className="popup_wrap"> <span className="close_icon" data-for="detachClose" data-tip onClick={ () => this.enableInstanceOperations("detach", "close", "") }></span>
                                <ReactToolTip id="detachClose" place='top' effect='solid'>Close</ReactToolTip>
                                <div className="popup_header">
                                    <div className="sub_title">Detach { this.state.detachInstancename }</div>
                                </div>
                                <div className="popup_body">
                                    <p>Are you sure you want to detach the instance from the load balancer?</p>
                                </div>
                                <div className="popup_footer">
                                    <div className="popup_footer__btns">
                                        <div className="btn btn_confirm" onClick={ (e) => this.detachAttchedInstance(e) }>Detach</div>
                                        <div className="btn btn_cancel" onClick={ () => this.enableInstanceOperations("detach", "close", "") }>Cancel</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CommonMessage message={ this.state.message } msgType={ this.state.msgType } isUserSubscribed={ this.state.isUserSubscribed } handler={ () => this.setState({ message: '' }) } />
            </div>
        );
    }
}
function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}
export default CreateLoadBal;